import { environment } from "src/environments/environment";

export const domain = {
  appURL: "http://localhost:8100/#/",
  URL: environment.apiBaseUrl + "Account/",
  dropdownCalls: environment.apiBaseUrl + "Master/",
  dropdownCallsAnyReports: environment.apiBaseUrl + "AnyReport/",
  addProperties: environment.apiBaseUrl + "Property/",
  SearchPropertyByNumber: environment.apiBaseUrl + "Property/SearchPropertyByNumber?",
  SearchLeadbyNumber: environment.apiBaseUrl + "AgentLead/SearchLeadbyNumber?",
  addLead: environment.apiBaseUrl + "AgentLead/AddLead",
  getMyLeads: environment.apiBaseUrl + "AgentLead/GetMyLeads?",
  getLeadById: environment.apiBaseUrl + "AgentLead/GetLeadById/",
  UpdateLead: environment.apiBaseUrl + "AgentLead/UpdateLead",
  deleteLead: environment.apiBaseUrl + "AgentLead/DeleteLead/",
  ExportCallingResponseData: environment.apiBaseUrl + "AgentLead/ExportCallingResponseData",
  ExportCallingLeads: environment.apiBaseUrl + "AgentLead/ExportCallingLeads",
  ImportLeadProperty: environment.apiBaseUrl + "AgentLead/ImportLeadProperty",
  ImportAgentProperty: environment.apiBaseUrl + "Property/ImportAgentProperty",
  assignLead: environment.apiBaseUrl + "AssignLead/AssignLead/",
  EditManager: environment.apiBaseUrl + "AssignLead/EditManager?",
  EditAdmin: environment.apiBaseUrl + "AssignLead/EditAdmin?",
  EditLeader: environment.apiBaseUrl + "AssignLead/EditLeader?",
  EditTeam: environment.apiBaseUrl + "AssignLead/EditTeam?",
  EditEmployee: environment.apiBaseUrl + "AssignLead/EditEmployee?",
  GetAllPropertyList: environment.apiBaseUrl + "Property/GetAllPropertyListUserTypeIdWise",
  anyReport: environment.apiBaseUrl + "AnyReport/",
  imageURL: environment.imageBaseUrl + "profilepics/",
  imageUrlProperty: environment.imageBaseUrl + "propertyimages/",
  activityURL: environment.apiBaseUrl + "Activities/",
  newProjectURL: environment.apiBaseUrl + "Project/",
  DownloadBrochureDocument: environment.apiBaseUrl + "Project/DownloadBrochureDocument",
  GetProjectProperties: environment.apiBaseUrl + "ProjectProperties/GetProjectProperties",
  RemoveProject: environment.apiBaseUrl + "Project/RemoveProject?projectId=",
  areaURL: environment.apiBaseUrl + "Area/",
  societyURL: environment.apiBaseUrl + "Society/",
  searchSociety: environment.apiBaseUrl + "Society/SearchSocietyList",
  imageUrlProject: environment.imageBaseUrl + "ProjectImages/",
  imageUrlFloorPlan: environment.imageBaseUrl + "ProjectFloorPlans/",
  ProjectBrochures: environment.imageBaseUrl + "ProjectBrochures/",
  imageUrlAgentProject: environment.imageBaseUrl + "AgentProjectImages/",
  getNewProjectImages: environment.apiBaseUrl + "Project/GetProjectImages?ProjectId=",
  sendIntrest: environment.apiBaseUrl + "ProjectLeads/SaveProjectLead?",
  getMyLeades: environment.apiBaseUrl + "ProjectLeads/GetProjectLeads?",
  getMyProjects: environment.apiBaseUrl + "Project/GetBuilderProjects?",
  SaveProjectImage: environment.apiBaseUrl + "Project/SaveProjectImage?projectId=",
  UploadBrochure: environment.apiBaseUrl + 'Project/UploadBrochure',
  DeleteProjectImage: environment.apiBaseUrl + 'Project/DeleteProjectImage?imageId=',
  UploadFloorPlan: environment.apiBaseUrl + 'ProjectProperties/UploadFloorPlan',
  ValidateUser: environment.apiBaseUrl + "Subscription/ValidateUser?",
  Notification: environment.apiBaseUrl + "PushNotification/",
  deviceRegistration: environment.apiBaseUrl + "devices/register",
  userDefineArea: environment.apiBaseUrl + "Area/",
  userDefineSociety: environment.apiBaseUrl + "Society/",
  saveOTP: environment.apiBaseUrl + "Account/SaveOTP",
  ValidateLoginUser: environment.apiBaseUrl + "Account/ValidateLoginUser",
  SaveSession: environment.apiBaseUrl + "Account/SaveSession",
  ValidateSession: environment.apiBaseUrl + "Account/ValidateSession",
  ValidateOTP: environment.apiBaseUrl + "Account/ValidateOTP",
  SignupSendotp: environment.apiBaseUrl + "Account/SignupSendotp",
  FreeTrialSubscription: environment.apiBaseUrl + "Subscription/FreeTrialSubscription?",
  DownloadFile: environment.apiBaseUrl + "Account/DownloadFile?fileName=",
  SignUpValidateRegOTP: environment.apiBaseUrl + "Account/SignUpValidateRegOTP",
  UsersSubscriptionList: environment.apiBaseUrl + "Subscription/UsersSubscriptionList?UserId=",
  SubscriptionListByServiceId: environment.apiBaseUrl + "Subscription/SubscriptionListByServiceId?serviceId=",
  saveProjectURL: environment.apiBaseUrl + 'Project/SaveProject',
  UpdateProject: environment.apiBaseUrl + 'Project/UpdateProject',
  SaveProjectProperty: environment.apiBaseUrl + 'ProjectProperties/SaveProjectProperty',
  UpdateProjectProperty: environment.apiBaseUrl + 'ProjectProperties/UpdateProjectProperty',
  DeleteProjectProperty: environment.apiBaseUrl + "ProjectProperties/DeleteProjectProperty?projectPropertyId=",


  //Agent Project
  // saveAgentProjectURL: environment.apiBaseUrl + 'AgentProject/SaveProject',
  // // UploadBrochure: environment.apiBaseUrl + 'Project/UploadBrochure',
  // SaveAgentProjectProperty: environment.apiBaseUrl + 'AgentProjectProperties/SaveProjectProperty',
  // UpdateAgentProjectProperty: environment.apiBaseUrl + 'AgentProjectProperties/UpdateProjectProperty',
  // getNewAgentProjectImages: environment.apiBaseUrl + "AgentProject/GetProjectImages?ProjectId=",
  // AgentsendIntrest: environment.apiBaseUrl + "AgentProjectLeads/SaveProjectLead?",
  // getMyAgentProjects: environment.apiBaseUrl + "AgentProject/GetBuilderProjects?",
  // newAgentProjectURL: environment.apiBaseUrl + "AgentProject/",
  // RemoveProject: environment.apiBaseUrl + "AgentProject/RemoveProject?projectId=",
  // GetAgentProjectProperties: environment.apiBaseUrl + "AgentProjectProperties/GetProjectProperties",
  // addAgentProjectImages: environment.apiBaseUrl + "AgentProject/SaveProjectImage?",
  // DeleteProjectProperty: environment.apiBaseUrl + "AgentProjectProperties/DeleteProjectProperty?projectPropertyId=",

  //Agent Team leads
  AddAgentUser: environment.apiBaseUrl + "AgentUser/AddAgentUser",
  UpdateAgentUser: environment.apiBaseUrl + "AgentUser/UpdateAgentUser",
  DeleteAgentUser: environment.apiBaseUrl + "AgentUser/DeleteAgentUser/",
  GetAgentUserById: environment.apiBaseUrl + "AgentUser/GetAgentUserById/",
  GetAgentUserList: environment.apiBaseUrl + "AgentUser/GetAgentUserList?",
  ValidateAgentUser: environment.apiBaseUrl + "AgentUser/ValidateAgentUser",
  AddTeam: environment.apiBaseUrl + "Team/AddTeam",
  GetTeamList: environment.apiBaseUrl + "Team/GetTeamList?",
  GetTeamDetails: environment.apiBaseUrl + "Team/GetTeamDetails/",
  DeleteTeam: environment.apiBaseUrl + "Team/DeleteTeam/",
  UpdateTeam: environment.apiBaseUrl + "Team/UpdateTeam",
  AddLeadHistory: environment.apiBaseUrl + "LeadHistory/AddLeadHistory",
  GetLeadHistoryByLeadId: environment.apiBaseUrl + "LeadHistory/GetLeadHistoryByLeadId?",
  RemoveTeamFromLead: environment.apiBaseUrl + "Team/RemoveTeamFromLead?",
  GetLeadActivityHistory: environment.apiBaseUrl + "PropertyActivity/GetLeadActivityHistory?",

  ///Agent Calling
  GetContactList: environment.apiBaseUrl + "CallingAgentContact/GetContactList?",
  GetContactUserList: environment.apiBaseUrl + "CallingAgentContact/GetContactUserList?",
  SaveContactReport: environment.apiBaseUrl + "CallingAgentContact/SaveContactReport",
  AssignContactToEmp: environment.apiBaseUrl + "CallingAgentContact/AssignContactToEmp",
  AssignContactsToMultipleEmp: environment.apiBaseUrl + "CallingAgentContact/AssignContactsToMultipleEmp",
  UnassignAllContacts: environment.apiBaseUrl + "CallingAgentContact/UnassignAllContacts",
  DeleteContacts: environment.apiBaseUrl + "CallingAgentContact/DeleteContacts",
  ImportContactsFromExcel: environment.apiBaseUrl + "CallingAgentContact/ImportContactsFromExcel",
  ContactCounts: environment.apiBaseUrl + "CallingAgentContact/ContactCounts?",
  AddAgentCallingLead: environment.apiBaseUrl + "CallingAgentLead/Add",
  UpdateAgentCallingLead: environment.apiBaseUrl + "CallingAgentLead/Update",
  DeleteAgentCallingLead: environment.apiBaseUrl + "CallingAgentLead/Delete",
  CallingAgentLeadList: environment.apiBaseUrl + "CallingAgentLead/List?",
  SearchActionTakenContactNumber: environment.apiBaseUrl + "CallingAgentContact/SearchActionTakenContactNumber?",
   GetContactListByType: environment.apiBaseUrl + "CallingAgentContact/GetContactListByType?",
  AddCallingMessage: environment.apiBaseUrl + "CallingAgentContact/AddCallingMessage",
  UpdateCallingMessage: environment.apiBaseUrl + "CallingAgentContact/UpdateCallingMessage",
  DeleteCallingMessage: environment.apiBaseUrl + "CallingAgentContact/DeleteCallingMessage",
  GetCallingMessagesList: environment.apiBaseUrl + "CallingAgentContact/GetCallingMessagesList?",
  RemoveCallingResponse: environment.apiBaseUrl + "CallingAgentContact/RemoveCallingResponse",

  // Agent connect
  sendrequest: environment.apiBaseUrl + "AgentConnect/sendrequest",
  ActOnRequest: environment.apiBaseUrl + "AgentConnect/ActOnRequest",
  GetPendingRequestCount: environment.apiBaseUrl + "AgentConnect/GetPendingRequestCount/",
  GetSentRequestList: environment.apiBaseUrl + "AgentConnect/GetSentRequestList/",
  GetPendingRequestList: environment.apiBaseUrl + "AgentConnect/GetPendingRequestList/",
  GetConnectionOverview: environment.apiBaseUrl + "AgentConnect/GetConnectionOverview/",
  RemoveConnection: environment.apiBaseUrl + "AgentConnect/RemoveConnection/",
  GetConnectionCounts: environment.apiBaseUrl + "AgentConnect/GetConnectionCounts/",
  GetConnectedSharePropertyAgentList: environment.apiBaseUrl + "AgentConnect/GetConnectedSharePropertyAgentList/",
  GetConnectedAgentSharePropertyList: environment.apiBaseUrl + "AgentConnect/GetConnectedAgentSharePropertyList/",
  SharePropertyToConnectedAgent: environment.apiBaseUrl + "Agent/SharePropertyToConnectedAgent/",


  //export data
  ExportAgentProperty: environment.apiBaseUrl + "Property/ExportAgentProperty",
  ExportMyLeads: environment.apiBaseUrl + "AgentLead/ExportMyLeads?",
  agentList: environment.apiBaseUrl + "Agent/",

  //campaning
  AddCampaign: environment.apiBaseUrl + 'AgentCampaign/AddCampaign',
  UpdateCampaign: environment.apiBaseUrl + 'AgentCampaign/UpdateCampaign',
  GetCampDetail: environment.apiBaseUrl + 'AgentCampaign/GetCampDetail?CampId=',
  GetCampList: environment.apiBaseUrl + 'AgentCampaign/GetCampList',
  GetSMSNumber: environment.apiBaseUrl + 'AgentCampaign/GetCampNumberList?IsWhatsApp=false&CampId=',
  GetWhatsAppNumber: environment.apiBaseUrl + 'AgentCampaign/GetCampNumberList?IsWhatsApp=true&CampId=',
  ImportCampNumber: environment.apiBaseUrl + 'AgentCampaign/ImportCampNumber?CampId=',
  DeleteCampNumber: environment.apiBaseUrl + 'AgentCampaign/DeleteCampNumber?Id=',
  SaveCampaignImage: environment.apiBaseUrl + 'AgentCampaign/SaveCampaignImage?CampId=',
  DeleteCampaignImage: environment.apiBaseUrl + 'AgentCampaign/DeleteCampaignImage?imageId=',
  SaveCampaignVideo: environment.apiBaseUrl + 'AgentCampaign/SaveCampaignVideo?CampId=',
  DeleteCampDetails: environment.apiBaseUrl + 'AgentCampaign/DeleteCampDetails?CampId=',
  DeleteCampaignVideo: environment.apiBaseUrl + 'AgentCampaign/DeleteCampaignVideo?videoId=',
  GetCampImage: environment.apiBaseUrl + 'AgentCampaign/GetCampImage?campId=',
  GetTigerDialSubscriptionDetails: environment.apiBaseUrl + 'AgentCampaign/GetTigerDialSubscriptionDetails',
  AddFreeCount: environment.apiBaseUrl + "Users/AddFreeCount?UserId=",
  GetFreeCount: environment.apiBaseUrl + "Users/GetFreeCount?UserId=",
  imageUrlcamp: environment.imageBaseUrl + "CampaignImages/",
  videoUrlcamp: environment.imageBaseUrl + "CampaignVideos/",

  //Support Ticket
  CreateSupportTicket: environment.apiBaseUrl + 'ticketsupport/create',
  UpdateSupportTicket: environment.apiBaseUrl + 'ticketsupport/update',
  GetAllSupportTickets: environment.apiBaseUrl + 'ticketsupport/getall',
  GetSupportTicketById: environment.apiBaseUrl + 'ticketsupport/get/',
  DeleteSupportTicket: environment.apiBaseUrl + 'ticketsupport/delete',

  //Support Ticket History
  PostTicketReply: environment.apiBaseUrl + 'ticketsupport/PostTicketReply',
  GetTicketHistory: environment.apiBaseUrl + 'ticketsupport/GetTicketHistory?Id=',
  getTicketHistoryList: environment.apiBaseUrl + 'ticketsupport/getTicketHistoryList?TicketId=',
  DeleteTicketHistory: environment.apiBaseUrl + 'ticketsupport/DeleteTicketHistory?Id=',

  //Social media share
  ShareProperty: environment.apiBaseUrl + "PdfExport/ExportPdf?type=",
  // ShareMyLeads: environment.apiBaseUrl + "AgentLead/ShareMyLeads?Id=",
  // ShareProject: environment.apiBaseUrl + "AgentProject/ShareProject?Id=",
  // ShareProjectProperties: environment.apiBaseUrl + "AgentProject/ShareProjectProperties?Id=",


  //SignalR
  RegisterConnection: environment.apiBaseUrl + 'SignalR/RegisterConnection',

  //custom menu
  AddCustomMenu: environment.apiBaseUrl + 'CustomMenu/AddCustomMenu',
  DeleteCustomMenu: environment.apiBaseUrl + 'CustomMenu/DeleteCustomMenu?menuId=',
  GetCustomMenuList: environment.apiBaseUrl + 'CustomMenu/GetCustomMenuList?UserId=',

  //User Group
  UserGroupCreate: environment.apiBaseUrl + "UserGroup/Create",
  UserGroupUpdate: environment.apiBaseUrl + "UserGroup/Update",
  UserGroupDelete: environment.apiBaseUrl + "UserGroup/Delete/",
  UserGroupUpdateActiveStatus: environment.apiBaseUrl + "UserGroup/UpdateActiveStatus",
  UserGroupGetByMainAgentId: environment.apiBaseUrl + "UserGroup/GetByMainAgentId/",
  UserGroupGetById: environment.apiBaseUrl + "UserGroup/GetById/",
  UserGroupAddMemberUserGroup: environment.apiBaseUrl + "UserGroup/AddMemberUserGroup",
  UserGroupGetAgentListForGroup: environment.apiBaseUrl + "UserGroup/GetAGentListForGroup",
  UserGroupRemoveMemberUserGroup: environment.apiBaseUrl + "UserGroup/RemoveMemberUserGroup/",
  UserGroupGetMemberGroupsByType: environment.apiBaseUrl + "UserGroup/GetMemberGroupsByType",
  UserGroupGetGroupMembersPropertyList: environment.apiBaseUrl + "UserGroup/GetGroupMembersPropertyList?GroupId=",
  UserGroupAcceptGroupRequest: environment.apiBaseUrl + "UserGroup/AcceptGroupRequest",
  UserGroupRejectGroupRequest: environment.apiBaseUrl + "UserGroup/RejectGroupRequest",


  //Plotting Project
  AddPlottingProject: environment.apiBaseUrl + 'PlottingProject/AddPlottingProject',
  UpdatePlottingProject: environment.apiBaseUrl + 'PlottingProject/UpdatePlottingProject',
  GetPlottingProjectById: environment.apiBaseUrl + 'PlottingProject/GetPlottingProjectById?PlotId=',
  GetAllPlottingProjectList: environment.apiBaseUrl + 'PlottingProject/GetAllPlottingProjectList',
  DeletePlottingProject: environment.apiBaseUrl + 'PlottingProject/DeletePlottingProject?plotingProjectId=',
  AddProjectDistance: environment.apiBaseUrl + 'PlottingProject/AddProjectDistance',
  UpdateProjectDistance: environment.apiBaseUrl + 'PlottingProject/UpdateProjectDistance',
  RemoveProjectToDistance: environment.apiBaseUrl + 'PlottingProject/RemoveProjectToDistance?Id=',
  AddProjectContact: environment.apiBaseUrl + 'PlottingProject/AddProjectContact',
  UpdateProjectContact: environment.apiBaseUrl + 'PlottingProject/UpdateProjectContact',
  RemoveProjectToContact: environment.apiBaseUrl + 'PlottingProject/RemoveProjectToContact?Id=',
  GetPlottingImageAndDocuments: environment.apiBaseUrl + 'PlottingProject/GetPlottingImageAndDocuments?PlotId=',
  SavePlottingImage: environment.apiBaseUrl + 'PlottingProject/SavePlottingImage',
  SavePlottingDocument: environment.apiBaseUrl + 'PlottingProject/SavePlottingDocument?plotId=',
  DeletePlottingDocument: environment.apiBaseUrl + 'PlottingProject/DeleteDocument?Id=',
  AddProjectPlot: environment.apiBaseUrl + 'PlottingProject/AddProjectPlot',
  UpdateProjectPlot: environment.apiBaseUrl + 'PlottingProject/UpdateProjectPlot',
  GetProjectPlots: environment.apiBaseUrl + 'PlottingProject/GetProjectPlots?plotId=',
  DeleteProjectPlot: environment.apiBaseUrl + 'PlottingProject/DeleteProjectPlot',
  imageUrlPlotting: environment.imageBaseUrl + 'PlottingImages/',
  documentUrlPlotting: environment.imageBaseUrl + 'PlottingDocuments/',

  //How to use app
  GetHowToUseAppList: environment.apiBaseUrl + 'HowToUseApp/GetHowToUseAppList',

  //Link URL
  AddNewLinkLead: "https://intercitybroker.com/" + "agent-home/add-new-link-lead/",
  
  //LinkPropertyDetails: "http://localhost:8100/" + "agent-home/link-property-details/",
   LinkPropertyDetails: "https://intercitybroker.com/" + "agent-home/link-property-details/",

  //PropertyDetails deeplink (opened via Android App Links / iOS Universal Links)
  PropertyDetailsLink: "https://intercitybroker.com/" + "agent-home/property-detail/",
  // PropertyDetailsLink: "http://localhost:8100/" + "agent-home/property-detail/",

  //ShareBuilderPropertyForm: "http://localhost:8100/" + "agent-home/share-builder-property-form/",
  ShareBuilderPropertyForm: "https://intercitybroker.com/" + "agent-home/share-builder-property-form/",
   

 //LinkProjectDetails: "http://localhost:8100/" + "agent-home/project-details-link-share/",
  LinkProjectDetails: "https://intercitybroker.com/" + "agent-home/project-details-link-share/",

  AddUserDevice: environment.apiBaseUrl + 'AdminAPI/AddUserDevice',



};
